import React from 'react'
import InProcessMerchantListDataTable from '../../components/Admin/InProcessMerchantList';

const InProcessMerchantList = () => {
    return (
        <InProcessMerchantListDataTable />
    )
}

export default InProcessMerchantList;
